export default "__VITE_ASSET__Bn4eNtY6__"